import { Subject } from 'rxjs'
import type { User } from './types'

const subject = new Subject<User>()

type UserUpdatedHandler = (user: User) => any
export const onAuthUserUpdated = (handler: UserUpdatedHandler) => subject.subscribe(handler)
export const emitAuthUserUpdate = (user: User) => subject.next(user)
